import { render } from "./PrivacyInfoControl.vue?vue&type=template&id=cfc59d54"
import script from "./PrivacyInfoControl.vue?vue&type=script&lang=js"
export * from "./PrivacyInfoControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__